import React from 'react';
import PaymentLinks from '../../components/create-payment-link/create-payment-link.component';

function PaymentLinksPage() {
  return (
    <>
      <PaymentLinks />
    </>
  );
}

export default PaymentLinksPage;
